<template>
  <div>
    <div class="ly_radio_button" v-bind:key="item.id" v-for="item in items">
      <label class="el_radio_button">
        <input
          class="el_radio_button_hidden"
          type="radio"
          v-model="selected"
          v-bind:value="item.name"
        />
        <span>{{ item.name }}</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaterialRadioButton',
  props: {
    // 本題の番号
    id: {
      type: String,
      default: null,
    },
    // 設問番号
    problem_id: {
      type: Number,
      default: null,
    },
    items: {
      type: Array,
      default: () => [
        { id: 1, name: 'する' },
        { id: 0, name: 'しない' },
        { id: 2, name: '未回答' },
      ],
    },
  },
  data: () => ({
    selected: '未回答',
  }),
  mounted() {
    if (this.id != null && this.problem_id != null) {
      try {
        const ans = this.$store.state.answer[this.id - 1].questions[
          this.problem_id - 1
        ].answer
        const nameMap = new Map([
          [1, 'する'],
          [0, 'しない'],
          [2, '未回答'],
        ])
        this.selected = nameMap.get(ans)
      } catch (e) {}
    }
  },
  watch: {
    selected() {
      try {
        this.$emit(
          'selected',
          this.items.find(item => {
            return item.name === this.selected
          }).id,
        )
      } catch (e) {
        console.error(e)
      }
    },
  },
}
</script>

<style scoped>
.ly_radio_button {
  white-space: nowrap;
  display: inline-flex;
  margin-left: 41px;
}

.el_radio_button input:checked + span {
  white-space: nowrap;
  color: white;
  padding: 7px 13px 7px 13px;
  margin-left: -13px;
  margin-right: -13px;
  background: #9fe8d6;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.25);
  border-radius: 21px;
  border: none;
	outline: none;  
}
.el_radio_button_hidden {
  white-space: nowrap;
  display: none;
}
</style>
